module.exports = __webpack_public_path__ + "static/render3-01717fcf070799451535fb9367ae4d60.jpg";